import React from "react";
import { Link } from 'react-router-dom'
// import Cookies from 'js-cookie';
import View from '../assets/images/view.svg';
import SearchBar from './SearchBar';
import AddIcon from '@mui/icons-material/Add';
// import Sorting from './Sorting';
import * as ActionTypes from '../actions/types';
import { connect } from 'react-redux';
// import { Tooltip } from "chart.js";
import { IconButton } from "@mui/material";
import SupportAssignTicket from "./SupportAssignTicket";

//support section page componenet
class Support extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: 'some error',
            ticketList: [],
            modalIsOpenAddSI: false,
            debounceTimeout: null,
            selectedTicketIds: [],
            searchValue: '',
            currentPage: 1, // Current page
            totalPages: 0, // Total pages from the API
            next: null, // Next page URL
            previous: null, // Previous page URL
            sortingStatus: {
                sortingName: '',
                defaultDown: true
            },
        }
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    openModal() {
        this.setState({
            modalIsOpenAddSI: false
        }, () => {
            this.setState({
                modalIsOpenAddSI: true
            })
        })
    }

    closeModal() {
        this.setState({ modalIsOpenAddSI: false });
    }

    resetSearchBar = () => {
        this.props.searchBarActivate(false)
    }

    restoreData = (data) => {
        this.setState({
            ticketList: data,
        })
    }

    componentDidMount() {
        this.resetSearchBar()
        this.fetchTickets()
    }

    fetchTickets = (url = '/cloud/supportticket/?page=1') => {
        const TokenValue = 'Token ' + localStorage.getItem("auth");

        fetch(url, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': TokenValue,
                'Access-Control-Allow-Origin': '*',
                'X-CSRFToken': localStorage.getItem('csrftoken'),
            },
        })
            .then((response) => {
                if (response.status === 403) {
                    localStorage.removeItem('token');
                    localStorage.removeItem('csrftoken');
                    localStorage.removeItem('auth');
                    window.location.href = '/session-timeout'
                } else {
                    return response.json();
                }
            })
            .then((data) => {
                if (data) {
                    this.setState({
                        ticketList: data.results,
                        totalCount: data.count,
                    });
                    const { results, next, previous } = data;
                    if (next) {
                        // Create a URL object
                        const next_url = new URL(next);

                        // Get the value of the "page" parameter
                        const nextValue = next_url.searchParams.get("page");
                        this.setState({
                            next: nextValue,
                        });
                    } else {
                        this.setState({
                            next: null
                        });
                    }
                    if (previous != null) {
                        // Create a URL object
                        const previous_url = new URL(previous);

                        // Get the value of the "page" parameter
                        const previousValue = previous_url.searchParams.get("page") || 1;
                        this.setState({
                            previous: previousValue,
                        });
                    } else {
                        this.setState({
                            previous: null
                        });
                    }
                }
            })
            .catch((error) => {
                console.error('Error fetching tickets:', error);
            });
    };


    handleSearch = (searchValue) => {
        clearTimeout(this.debounceTimeout); // Clear previous timeout
        this.debounceTimeout = setTimeout(() => {
            this.fetchTickets(`/cloud/supportticket/?search=${searchValue}`);
        }, 500); // Wait for 500ms before making API call
    };

    handleNextPage = () => {
        const { next } = this.state;
        if (next) {
            console.log('Fetching next page from:', next);
            this.fetchTickets(`/cloud/supportticket?page=${next}&search=${this.state.searchValue}`);
        }
    };

    handlePreviousPage = () => {
        const { previous } = this.state;
        if (previous) {
            this.fetchTickets(`/cloud/supportticket?page=${previous}&search=${this.state.searchValue}`);
        }
    };


    renderPagination() {
        const { next, previous, totalCount, ticketList } = this.state;

        // No pagination if no tickets
        if (!ticketList.length) return null;

        return (
            <div style={{ margin: '20px 0', textAlign: 'center', }}>
                <button
                    onClick={this.handlePreviousPage}
                    disabled={!previous} // Disable if there's no previous page
                    style={{
                        margin: '0 10px',
                        padding: '5px 10px',
                        backgroundColor: previous ? '#00b0a9' : '#ccc',
                        color: 'white',
                        border: 'none',
                        cursor: previous ? 'pointer' : 'not-allowed',
                        outline: 'none',
                        borderRadius: '5px'
                    }}
                >
                    Previous
                </button>

                <button
                    onClick={this.handleNextPage}
                    disabled={!next} // Disable if there's no next page
                    style={{
                        margin: '0 10px',
                        padding: '5px 10px',
                        backgroundColor: next ? '#00b0a9' : '#ccc',
                        color: 'white',
                        border: 'none',
                        cursor: next ? 'pointer' : 'not-allowed',
                        outline: 'none',
                        borderRadius: '5px'
                    }}
                >
                    Next
                </button>
            </div>
        );
    }

    clearSelectedTicketIds = () => {
    this.setState({ selectedTicketIds: [] });
};


    ActivateSIModel = (e) => {
        if (this.state.modalIsOpenAddSI) {
            return <SupportAssignTicket    clearSelectedTicketIds={this.clearSelectedTicketIds}  selectedTicketIds={this.state.selectedTicketIds} activeModal={true} closeAllModal={this.closeAllModal.bind(this)} />
        } else {
            return null
        }
    }


    closeAllModal = (e) => {
        this.fetchTickets()
        this.setState({
            modalIsOpenAddSI: false,
            modalIsOpenAddSIView: false,
            modalIsOpenSIProject: false,
            modalIsOpenOkasBoxes: false,
            modalIsOpenAddSIEdit: false,
            modalIsOpenDelete: false,
        })
    }

    handleAssignTicketClick = () => {
        const { selectedTicketIds } = this.state;

        if (!selectedTicketIds || selectedTicketIds.length === 0) {
            alert("Please select at least one ticket to assign.");
            this.setState({ modalIsOpenAddSI: false }); // ✅ Correct way to close modal via state
            return;
        }

        // Proceed with showing modal or assignment logic
        // console.log("Selected Ticket IDs:", selectedTicketIds);

        this.setState({ modalIsOpenAddSI: true }); // Or any logic to open a modal
    };





    render() {
        return (
            <React.Fragment>
                <div style={{ width: '100%', paddingLeft: '5px', paddingTop: '40px', paddingRight: '20px' }}>
                    {!this.props.redux.auth.searchBarShow ? <div style={{ marginBottom: '20px' }}>
                        <span style={{ color: '#888888', fontSize: '30px', }}>SUPPORT</span>
                        <span style={{ float: 'right' }}>
                            {!this.props.redux.auth.searchBarShow ? (
                                <div className="row" style={{ margin: '0' }}>
                                    <div
                                        className="pointer"
                                        onClick={this.handleAssignTicketClick}
                                        style={{ display: 'inline-block' }}
                                    >
                                        <div
                                            className="buttonContent"
                                            style={{
                                                backgroundColor: 'white',
                                                boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2)',
                                            }}
                                        >
                                            <IconButton
                                                sx={{
                                                    color: '#F08100',
                                                    fontSize: 40,
                                                    backgroundColor: 'transparent',
                                                    '&:hover': { backgroundColor: 'transparent' },
                                                    '&:focus': {
                                                        outline: 'none',
                                                        border: 'none',
                                                        backgroundColor: 'transparent',
                                                    },
                                                }}
                                                aria-label="add"
                                            >
                                                <AddIcon sx={{ fontSize: 40 }} />
                                            </IconButton>
                                            <span
                                                style={{
                                                    color:
                                                        this.state.selectedTicketIds.length === 0
                                                            ? '#cccccc'
                                                            : '#928888',
                                                    fontSize: '10px',
                                                    fontWeight: '600',
                                                    cursor:
                                                        this.state.selectedTicketIds.length === 0
                                                            ? 'not-allowed'
                                                            : 'pointer',
                                                }}
                                            >
                                                ASSIGN TICKET
                                            </span>
                                        </div>
                                    </div>

                                    {/* ⬇️ Move this outside the button area */}
                                    {/* {this.state.modalIsOpenAddSI && (
                                        <SupportAssignTicket
                                            selectedTicketIds={this.state.selectedTicketIds}
                                            closeAllModal={this.closeAllModal.bind(this)}
                                        />
                                        // <></>
                                    )} */}
                                </div>
                            ) : null}

                        </span>
                    </div> : <div className='animated animated-duration-custom slideInDown pb-3 mt-2 flex-fill'>
                        <SearchBar autoFocus
                            value={this.state.searchValue}
                            onChange={(e) => {
                                this.setState({
                                    searchValue: e
                                }, () => {
                                    this.handleSearch(this.state.searchValue)
                                })
                            }
                            }
                            onRequestSearch={() => this.handleSearch(this.state.searchValue)}

                            resetSearch={(e) => {
                                if (!e) {
                                    // Close button clicked, reset everything
                                    this.setState({ searchValue: "" }, () => {
                                        this.handleSearch(""); // Fetch default data
                                    });
                                } else {
                                    // Normal reset behavior
                                    this.setState({ searchValue: e }, () => {
                                        this.handleSearch(this.state.searchValue);
                                    });
                                }
                            }}
                        /></div>}


                    <div style={{ marginTop: '1%' }}>
                        <thead style={{ backgroundColor: '#00b0a9', padding: '1%', paddingRight: '0px', color: 'white', borderRadius: '10px 10px 0px 0px' }}>
                            <th style={{ width: '5%', fontSize: '12px' }}></th>
                            <th style={{ width: '10%', fontSize: '12px' }}>Ticket ID</th>
                            <th style={{ width: '10%', fontSize: '12px' }}>Status</th>
                            <th style={{ width: '10%', fontSize: '12px' }}>SI Info</th>
                            <th style={{ width: '10%', fontSize: '12px' }}>Distributor Info</th>
                            <th style={{ width: '10%', fontSize: '12px' }}>Assigned To OKAS</th>
                            <th style={{ width: '10%', fontSize: '12px' }}>Project Details</th>
                            <th style={{ width: '10%', fontSize: '12px' }}>Location</th>
                            <th style={{ width: '12%', fontSize: '12px' }}>Subscription Status</th>
                            <th style={{ width: '10%', fontSize: '12px' }}>Remort Access</th>
                            <th style={{ width: '10%', fontSize: '12px' }}>Action</th>
                        </thead>
                        {this.ActivateSIModel()}
                        <table style={{ minWidth: '0px', paddingLeft: '0px', paddingRight: '0px' }} className="table table-striped">
                            <tbody style={{ maxHeight: '60vh' }}>
                                {this.state.ticketList.map((firstElement) => {

                                    return (
                                        <tr>
                                            <td style={{ width: '5%', fontSize: '12px' }}>
                                                <input
                                                    type="checkbox"
                                                    checked={(this.state.selectedTicketIds || []).includes(firstElement.custom_ticket_id)}
                                                    onChange={(e) => {
                                                        const { selectedTicketIds } = this.state;
                                                        const isChecked = e.target.checked;
                                                        const id = firstElement.custom_ticket_id;

                                                        this.setState({
                                                            selectedTicketIds: isChecked
                                                                ? [...selectedTicketIds, id]
                                                                : selectedTicketIds.filter(tid => tid !== id)
                                                        });
                                                    }}
                                                />

                                            </td>

                                            <td style={{ width: '10%', fontSize: '12px' }}>
                                                {(firstElement.custom_ticket_id).padStart(3, '0')}
                                            </td>

                                            <td
                                                style={{
                                                    width: '10%', fontSize: '12px',
                                                    color:
                                                        firstElement.ticket_status === 'closed'
                                                            ? 'red'
                                                            : firstElement.ticket_status === 'hold'
                                                                ? 'orange'
                                                                : firstElement.ticket_status === 'open'
                                                                    ? '#46ad78'
                                                                    : firstElement.ticket_status === 'resolved'
                                                                        ? '#D5D528'
                                                                        : 'black', // Default color
                                                    fontWeight: 'bold', // Optional for better readability

                                                }}
                                            >
                                                {firstElement.ticket_status ? firstElement.ticket_status.toUpperCase() : 'N/A'}
                                            </td>
                                            <td style={{ width: '10%', fontSize: '12px' }}>
                                                {firstElement.si_email}
                                            </td>
                                            <td style={{ width: '10%', fontSize: '12px' }}>
                                                {firstElement.distributor_email}
                                            </td>

                                            <td style={{ width: '10%', fontSize: '12px' }}>
                                                {firstElement.is_assigned_to_okas ? "Y" : "N"}
                                            </td>

                                            <td style={{ width: '10%', fontSize: '12px' }}>
                                                <div>
                                                    <div>
                                                        {firstElement.project_building && firstElement.project_building.owner_name || 'N/A'}
                                                    </div>
                                                    <div>
                                                        {firstElement.project_building && firstElement.project_building.user || 'N/A'}
                                                    </div>
                                                </div>
                                            </td>

                                            <td style={{ width: '10%', fontSize: '12px' }}>
                                                {firstElement.project_building && firstElement.project_building.address || 'N/A'}
                                            </td>
                                            <td style={{ width: '12%', fontSize: '12px' }}>
                                                {firstElement.subscription_data && firstElement.subscription_data.is_subscribed ? 'Y' : 'N'}
                                            </td>

                                            {/* <td style={{ width: '10%' }}>{firstElement.remote_access} </td> */}
                                            <td style={{ width: '10%', fontSize: '12px' }}>
                                                {firstElement.remote_access ? 'Y' : 'N'}
                                            </td>

                                            <td style={{ width: '10%', textAlign: 'center', fontSize: '12px' }}>
                                                <Link to={{
                                                    pathname: `/supportremoteaccess/${firstElement.ticket_id}`,
                                                    item: {
                                                        ticket: `${firstElement.ticket_id}`
                                                    }
                                                }}>
                                                    <img
                                                        src={View}
                                                        alt="View Icon"
                                                        style={{ width: '17px', height: '17px' }}
                                                    />

                                                </Link>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                    {this.renderPagination()}
                </div>
            </React.Fragment>
        )
    }
}


const mapStateToProps = state => {
    return {
        redux: state,
    };
};



const mapDispatchToProps = dispatch => {
    return {
        searchBarActivate: (data) => dispatch({ type: ActionTypes.SEARCHBAR, data: data }),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Support);